module.exports = __webpack_public_path__ + "img/待办汇总@2x.755d5c40.png";